import React from 'react';
import Content from "../show/Content";

const Persona = ({persona}) => (
  <Content persona={persona}/>
);

export default Persona